import React from 'react';
import { Outlet, useParams } from 'react-router';
import { Route } from '@reverbdotcom/commons/src/route_settings';

// The shop components read the route params from a `params` prop (injected
// by the v3 router; their own conversion happens in the withRouter sweep).
function lazyWithParams(load: () => Promise<{ default: React.ComponentType<any> }>) {
  return async () => {
    const Component = (await load()).default;

    return {
      Component: function ShopRoutePage() {
        const params = useParams();

        return <Component params={params} />;
      },
    };
  };
}

const lazyShopContainer = async () => {
  const ShopContainer = (await import(
    /* webpackChunkName: 'shop' */
    '../components/discovery/shops/shop_container'
  )).default;

  return {
    Component: function ShopContainerPage() {
      const params = useParams();

      return (
        <ShopContainer params={params}>
          <Outlet />
        </ShopContainer>
      );
    },
  };
};

const ShopRoutes = (
  <Route
    key="shop/:shop"
    path="shop/:shop"
    handle={{ clientSide: true }}
    lazy={lazyShopContainer}
  >
    <Route
      index
      lazy={lazyWithParams(() => import(
        /* webpackChunkName: 'shop' */
        '../components/marketplace/shop_page'
      ))}
    />
    <Route
      key="feedback"
      path="feedback"
      lazy={lazyWithParams(() => import(
        /* webpackChunkName: 'shop' */
        '../components/discovery/shops/shop_feedback'
      ))}
    />
    <Route
      key="about"
      path="about"
      lazy={lazyWithParams(() => import(
        /* webpackChunkName: 'shop' */
        '../components/discovery/shops/shop_info'
      ))}
    />
  </Route>
);

export {
  ShopRoutes,
};
